/*
 * Mini cart
 */

class MiniCart {
	constructor() {
		this.body = document.querySelector( 'body' );
		this.header = document.querySelector( 'header.site-header' );
		this.wrapper = document.querySelector( '[data-mini-cart-wrapper]' );
		this.overlay = document.querySelector( '[data-site-overlay]' );

		// Document ready.
		document.defaultView.addEventListener( 'load', this.events.bind( this ) );
	}

	events() {
		// Since button is replaced by AJAX we add the event listener to the header
		// and then check if the target is the button.
		this.header.addEventListener( 'click', e => {
			if ( e.target.closest( '[data-mini-cart-wrapper]' ) ) {
				this.miniCartTriggered( e );
			}
		} );

		this.body.ownerDocument.addEventListener( 'click', this.outsideClickListener.bind( this ) );
	}

	miniCartTriggered( e ) {
		e.stopPropagation();

		const miniCart = document.querySelector( '.widget_shopping_cart' );

		if ( ! miniCart ) {
			return;
		}

		if ( ! e.target.closest( '.widget_shopping_cart' ) ) {
			if ( this.cartIsHidden( miniCart ) ) {
				this.hideCart( miniCart );
				return;
			}
		}

		this.showCart( miniCart );
	}

	outsideClickListener( e ) {
		const miniCart = document.querySelector( '.widget_shopping_cart' );

		if ( ! miniCart ) {
			return;
		}

		if ( ! e.target.closest( '.widget_shopping_cart' ) ) {
			if ( this.cartIsHidden( miniCart ) ) {
				this.hideCart( miniCart );
			}
		}
	}

	removeClickListener() {
		this.body.ownerDocument.removeEventListener( 'click', this.outsideClickListener );
	}

	showCart( miniCart ) {
		const trigger = document.querySelector( '[data-mini-cart-button]' );
		const triggerRect = trigger.getBoundingClientRect();
		const headerRect = this.header.getBoundingClientRect();

		this.wrapper.classList.add( 'mini-cart-enter' );
		miniCart.style.top = `${ 20 + headerRect.top + headerRect.height - triggerRect.top }px`;
		this.body.classList.add( 'no-scroll', 'show-overlay' );
		setTimeout( () => {
			this.wrapper.classList.add( 'mini-cart-enter-active' );
		}, 50 );
	}

	hideCart( miniCart ) {
		miniCart.style.top = '';
		this.wrapper.classList.remove( 'mini-cart-enter', 'mini-cart-enter-active' );
		this.body.classList.remove( 'no-scroll', 'show-overlay' );
		this.removeClickListener();
		// Also trigger the WC event update_checkout if this happened on checkout page.
		jQuery( document.body ).trigger( 'update_checkout' );
	}

	// Test if cart is hidden, won't work if mini cart is set to fixed position
	// https://stackoverflow.com/a/21696585
	cartIsHidden( miniCart ) {
		return ( null !== miniCart.offsetParent );
	}
}

/*eslint-disable */
/**
 * Element.closest() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 *
 */
if ( ! Element.prototype.closest ) {
	if ( ! Element.prototype.matches ) {
		Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	}
	Element.prototype.closest = function( s ) {
		let el = this;
		let ancestor = this;
		if ( ! document.documentElement.contains( el ) ) {return null;}
		do {
			if ( ancestor.matches( s ) ) {return ancestor;}
			ancestor = ancestor.parentElement;
		} while ( null !== ancestor );
		return null;
	};
}
/*eslint-enable */

export default MiniCart;
